module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAaVBMVEUAAADNzc3Ozs7e3t7Nzc3Nzc3Nzc3MzMzNzc3Nzc3MzMzPz8/W1tbZ2dnOzs7Nzc3MzMzMzMzMzMzMzMzNzc3MzMzMzMzMzMzNzc3MzMzNzc3MzMzNzc3Q0NDR0dHR0dHMzMzMzMzMzMz6AOl4AAAAInRSTlMA+jIF9fDl36+iPx0PClJJ7OjYz8rEw7+5l5CIejcsJyMUGHi4QwAAAHxJREFUOMvt1DcCgzAQRFHANpicc577HxI62q8GGqZ+hbTJevN8JtfBdpSN8SA7obYXt76+KaSf0wbU/vUzsTO0cafMobZVvkAb1XJXait5G7R7KS+0YBoVzHLMn8E/yEvHm8LbzQeJjygffsO14gt7aXwK+JExO19v7s8BsiIItrkrwXoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/cal_arrow_left.png
// module id = tOv9
// module chunks = 3